const assignmentStatusList = [
  {
    id: 10,
    name: 'Stand by'
  },
  {
    id: 15,
    name: 'Concurrent'
  },
  {
    id: 20,
    name: 'Placed'
  },
  {
    id: 25,
    name: 'Completed'
  }
];

export default assignmentStatusList;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/drop-down-tables/assignmentStatusList.js